module.exports = __webpack_public_path__ + "static/img/shengjiang.7c9f6298.png";